<template>
  <div class="v2-home container-fluid py-3">
    <div class="d-flex justify-content-start mb-3">
      <button type="button" class="btn btn-primary btn-sm" @click="carregarItens()">
        Atualizar
      </button>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6 mb-3">
        <div class="v2-col-main">
          <section class="mb-4">
            <h4 class="v2-section-title">Ao Vivo</h4>
            <V2EventList
              :itens="itens"
              :filtroSituacao="[3]"
              :itensFavoritos="itensFavoritos"
              :gmt="gmtUsuario"
              @visualizar="abrirEvento"
            />
          </section>

          <section class="mb-4">
            <h4 class="v2-section-title">Previstos</h4>
            <V2EventList
              :itens="itens"
              :filtroSituacao="[1]"
              :itensFavoritos="itensFavoritos"
              :gmt="gmtUsuario"
              @visualizar="abrirEvento"
            />
          </section>

          <section class="mb-4" v-if="isAdmin">
            <h4 class="v2-section-title">Fontes</h4>
            <V2EventList
              :itens="itens"
              :filtroSituacao="[2]"
              :itensFavoritos="itensFavoritos"
              :gmt="gmtUsuario"
              @visualizar="abrirEvento"
            />
          </section>

          <section class="mb-0">
            <h4 class="v2-section-title">Encerrados</h4>
            <V2EventList
              :itens="itens"
              :filtroSituacao="[4]"
              :itensFavoritos="itensFavoritos"
              :gmt="gmtUsuario"
              @visualizar="abrirEvento"
            />
          </section>
        </div>
      </div>

      <div class="col-12 col-lg-4 mb-3">
        <V2EventViewer :selectedEventoId="eventoSelecionadoId" />
      </div>

      <div class="col-12 col-lg-2 mb-3">
        <div class="v2-col-box v2-col-empty"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "@/includes/util.js";
import V2EventList from "@/v2/components/V2EventList.vue";
import V2EventViewer from "@/v2/components/V2EventViewer.vue";

export default {
  name: "HomeV2",
  components: {
    V2EventList,
    V2EventViewer,
  },
  data() {
    return {
      isAdmin: false,
      itens: [],
      itensFavoritos: {},
      eventoSelecionadoId: "",
      gmtUsuario: -3,
    };
  },
  methods: {
    abrirEvento(item) {
      this.eventoSelecionadoId = item && item._id ? item._id : "";
    },
    async carregarItens() {
      let filtros = "?_limit=600";

      const itensFavoritosTemp = {};
      const responseFavorito = await api.get("/favorito");

      if (responseFavorito.data.erro == false) {
        for (let i = 0; i < responseFavorito.data.itens.length; i++) {
          const favorito = responseFavorito.data.itens[i];
          itensFavoritosTemp[favorito.evento] = favorito;
        }
      }

      this.itensFavoritos = itensFavoritosTemp;

      let routeEvento = "/evento";
      if (
        this.$sessao &&
        this.$sessao.usuario &&
        Object.keys(this.$sessao.usuario).includes("tipoUsuario") &&
        this.$sessao.usuario.tipoUsuario == "Assinante"
      ) {
        routeEvento = "/evento/cache";
      }

      const response = await api.get(routeEvento + filtros);
      api.valid(response.data, this.$router);

      const arrEventos = [];

      for (let i = 0; i < response.data.itens.length; i++) {
        const item = response.data.itens[i];

        item.competicaoPais = "";

        if (item.competicao && item.competicao !== "") {
          const arrCompeticao = item.competicao.split(",");
          if (arrCompeticao.length > 0) {
            item.competicaoPais = util.countryNameToCode(arrCompeticao[0]).toLowerCase();
          }
        }

        item.competicaoPaisUrl =
          item.competicaoPais == ""
            ? "/assets/worldflag3.png"
            : "https://flagcdn.com/h20/" + item.competicaoPais + ".png";

        if (item.site !== "Extra") {
          arrEventos.push(item);
        }
      }

      this.itens = arrEventos;
    },
  },
  mounted() {
    this.isAdmin =
      this.$sessao &&
      this.$sessao.usuario &&
      this.$sessao.usuario.tipoUsuario == "Administrador";

    if (this.$sessao && this.$sessao.usuario && this.$sessao.usuario.gmt != null) {
      const gmt = parseInt(this.$sessao.usuario.gmt, 10);
      this.gmtUsuario = Number.isNaN(gmt) ? -3 : gmt;
    }

    this.carregarItens();

    this.intervalCarregar = setInterval(() => {
      this.carregarItens();
    }, 20000);
  },
  beforeDestroy() {
    if (this.intervalCarregar) {
      clearInterval(this.intervalCarregar);
    }
  },
};
</script>

<style scoped>
.v2-home {
  min-height: calc(100vh - 120px);
}

.v2-col-main {
  background: transparent;
  border: 0;
  padding: 0;
}

.v2-col-box {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  min-height: 320px;
}

.v2-col-empty {
  background: #fafafa;
}

.v2-section-title {
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
}
</style>
